import { IImbpBooking } from "@/models/imbpBooking/imbpBooking.types"
import { IImbpBookingInformation } from "./imbpBookingInformation.types"
import dayjs from "dayjs"
export class ImbpBookingInformation implements IImbpBookingInformation {
  bookings: IImbpBooking[]

  constructor(data: { bookings: IImbpBooking[] }) {
    this.bookings = data.bookings
  }

  get latestBooking() {
    if (!this.bookings.length) return null
    return this.bookings.reduce((latestBooking, currentBooking) => {
      return dayjs(currentBooking.createdAt).isAfter(
        dayjs(latestBooking.createdAt),
      )
        ? currentBooking
        : latestBooking
    }, this.bookings[0])
  }

  get hasActiveBooking() {
    return this.bookings.some((booking) =>
      dayjs(booking.slotStartDateTime).isAfter(dayjs()),
    )
  }
}
